<template>
  <div id="add_broadcast" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            v-if="broadcastParam.broadcast_id!='' && broadcastParam.broadcast_id!=null"
          >Edit Broadcast / Direct Chats</h5>
          <h5 class="modal-title" v-else>Add Broadcast / Direct Chats</h5>
          <!-- {{broadcastParam.broadcast_id}} -->
          <!-- {{broadcastParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="tab-content">
            <div :class="(tabMessage=='setup')?'tab-pane show active':'tab-pane' " id="form">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Title:</label>
                        <input type="text" class="form-control" v-model="broadcastParam.title" />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Message Options:</label>
                            <button
                              class="btn btn-lg btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-if="uploadMessageSupportSelected==''"
                              :style="'width:100%;'"
                            >Options</button>
                            <button
                              class="btn btn-lg btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              :style="'width:100%;'"
                              v-else
                            >
                              <span v-if="uploadMessageSupportSelected=='text only'">
                                <i class="fa fa-font"></i> Text only
                              </span>
                              <span v-else>
                                <i class="fa fa-image"></i> Media
                              </span>
                            </button>
                            <div class="dropdown-menu">
                              <a
                                @click.prevent="updateMessageSupportCurrent(opt)"
                                class="dropdown-item"
                                :style="'width:100%;'"
                                href="#"
                                v-for="(opt,index) in messageTypeOptionsSupport"
                                :key="index"
                              >
                                <i
                                  class="text-success fa fa-check-circle"
                                  v-if="uploadMessageSupportSelected==opt"
                                ></i>
                                {{opt}}
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <label>Select License:</label>
                            <!-- {{selectedLicense}} -->
                            <div class="input-group m-b-30">
                              <multiselect
                                :class="'form-control'"
                                v-model="selectedLicense"
                                id="ajax"
                                label="license_name"
                                track-by="id"
                                :placeholder="(typeof(selectedLicense)!='undefined' && typeof(selectedLicense.license_name)!='undefined'?selectedLicense.license_name:'')"
                                open-direction="bottom"
                                :custom-label="customLabelLicense"
                                :options="licenseOptions"
                                :multiple="true"
                                :searchable="true"
                                :loading="isLoadingLicense"
                                :internal-search="false"
                                :close-on-select="false"
                                :options-limit="300"
                                :limit="3"
                                :limit-text="limitText"
                                :max-height="600"
                                :show-no-results="true"
                                :hide-selected="true"
                                @search-change="asyncFindLicenseSelect"
                                :show-labels="false"
                              >
                                <template slot="tag" slot-scope="{ option, remove }">
                                  <span class="custom__tag">
                                    <span>{{ option.license_name+" ("+option.license_phone_number+")" }}</span>
                                    <span class="custom__remove" @click="remove(option)">❌</span>
                                  </span>
                                </template>
                                <template slot="clear" slot-scope="props">
                                  <div
                                    class="multiselect__clear"
                                    v-if="typeof(selectedLicense.length)!='undefined' && selectedLicense.length"
                                    @mousedown.prevent.stop="clearAllLicense(props.search)"
                                  ></div>
                                </template>
                                <span slot="noResult">Oops! No elements found.</span>
                              </multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Destination:</label>
                        <div class="input-group m-b-30">
                          <div class="input-group-prepend">
                            <button
                              class="btn btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='group'"
                            >Group</button>
                            <button
                              class="btn btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-else-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='tags'"
                            >Tags</button>
                            <button
                              class="btn btn-outline-secondary dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-else
                            >Contact</button>
                            <div class="dropdown-menu">
                              <a
                                @click.prevent="changeDestination(1,'group')"
                                class="dropdown-item"
                                href="#"
                              >
                                <i
                                  :class="((broadcastParam.is_group==1 && broadcastParam.is_group_type=='group')?'text-success':'')+' fa fa-users'"
                                ></i>
                                Group
                              </a>
                              <a
                                @click.prevent="changeDestination(1,'tags')"
                                class="dropdown-item"
                                href="#"
                              >
                                <i
                                  :class="((broadcastParam.is_group==1 && broadcastParam.is_group_type=='tags')?'text-success':'')+' fa fa-tags'"
                                ></i>
                                Tags
                              </a>
                              <a
                                @click.prevent="changeDestination(0,'')"
                                class="dropdown-item"
                                href="#"
                              >
                                <i
                                  :class="((broadcastParam.is_group==0)?'text-success':'')+' fa fa-user'"
                                ></i>
                                Contact
                              </a>
                            </div>
                          </div>
                          <multiselect
                            v-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='group'"
                            :class="'form-control'"
                            v-model="selectedContactGroup"
                            id="ajax"
                            label="name"
                            track-by="id"
                            placeholder="Type to search group"
                            open-direction="bottom"
                            :custom-label="customLabelGroup"
                            :options="contactOptionsGroup"
                            :multiple="true"
                            :searchable="true"
                            :loading="isLoadingGroup"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFindGroup"
                            :show-labels="false"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedContactGroup.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                          <multiselect
                            v-if="broadcastParam.is_group==1 && broadcastParam.is_group_type=='tags'"
                            v-model="tagsSelected"
                            class="form-control"
                            placeholder="Type to search tags"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :multiple="true"
                            :custom-label="tagsCustomLabel"
                            :options="tagsOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="tagsLimitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="tagsAsyncFind"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="tagsSelected.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                          <!-- {{selectedContact}} -->
                          <multiselect
                            v-if="broadcastParam.is_group==0"
                            :class="'form-control'"
                            v-model="selectedContact"
                            id="ajax"
                            label="first_name"
                            track-by="phone_number"
                            placeholder="Type to search contact"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="contactOptions"
                            :multiple="true"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFind"
                            :show-labels="false"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span
                                  v-if="option.is_group==1"
                                >{{ option.first_name +" ("+ option.provider+")" }}</span>
                                <span v-else>{{ option.first_name +" ("+ option.phone_number+")" }}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedContact.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="uploadMessageSupportSelected!='text only'">
                      <div class="form-group">
                        <table class="table table-active">
                          <tr>
                            <th class="text-right">Url File</th>
                            <th style="width:30%;" class="text-left">
                              <div class="onoffswitch">
                                <input
                                  type="checkbox"
                                  name="onoffswitch"
                                  class="onoffswitch-checkbox"
                                  v-model="broadcastParam.is_custom_url"
                                  id="switch_url_file"
                                />
                                <label class="onoffswitch-label" for="switch_url_file">
                                  <span class="onoffswitch-inner"></span>
                                  <span class="onoffswitch-switch"></span>
                                </label>
                              </div>
                            </th>
                            <th class="text-center">
                              <label>Select Message Type &amp; Upload File</label>
                              <!-- {{broadcastParam.message}} -->
                              <!-- {{broadcastParam.message.file_url}} -->
                              <p
                                v-if="broadcastParam.broadcast_id!='' && broadcastParam.message.file_url!=''"
                              >
                                <a
                                  v-if="broadcastParam.message.message_type=='document'"
                                  target="_blank"
                                  :href="broadcastParam.message.file_url"
                                >
                                  <i class="fa fa-file"></i> File
                                </a>
                                <a
                                  v-if="broadcastParam.message.message_type=='image'"
                                  target="_blank"
                                  :href="broadcastParam.message.file_url"
                                >
                                  <img :src="broadcastParam.message.file_url" style="width:100px;" />
                                </a>
                              </p>
                              <button
                                class="btn btn-outline-secondary dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                v-if="uploadMessageType==''"
                              >Options</button>
                              <button
                                :style="'margin:5px;'"
                                class="btn btn-outline-secondary dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                v-else
                              >{{uploadMessageType}}</button>
                              <div class="dropdown-menu">
                                <a
                                  @click.prevent="updateMessageTypeCurrent(opt)"
                                  class="dropdown-item"
                                  href="#"
                                  v-for="(opt,index) in messageTypeOptionsUpload"
                                  :key="index"
                                >
                                  <i
                                    class="text-success fa fa-check-circle"
                                    v-if="uploadMessageType==opt"
                                  ></i>
                                  {{opt}}
                                </a>
                              </div>
                            </th>
                          </tr>
                        </table>

                        <div
                          v-show="files.length==0 && broadcastParam.is_custom_url==false"
                          class="col-md-12 upload-drop-zone"
                          id="drop-zone"
                        >
                          <center>
                            <i class="fa fa-cloud-upload fa-2x"></i>
                            <span class="upload-text">
                              <label :for="name">
                                Just drag and
                                drop file here
                              </label>
                            </span>
                          </center>
                        </div>
                        <div>
                          <!-- <form id="js-upload-form"> -->

                          <div class="col-md-12" v-if="broadcastParam.is_custom_url==true">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label>Image / File URL</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="broadcastParam.message.file_url"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12" v-if="broadcastParam.is_custom_url==false">
                            <!-- {{files}} -->
                            <!-- <h4 v-if="files.length">Uploading</h4> -->
                            <ul class="upload-list" v-if="files.length">
                              <li v-for="file in files" :key="file.id" class="file-list">
                                <div class="upload-wrap">
                                  <div class="file-name">
                                    <!-- <i class="fa fa-photo"></i> -->
                                    <img style="width:30px;" v-if="file.thumb" :src="file.thumb" />
                                    {{file.name}}
                                  </div>
                                  <div class="file-size">{{formatSizes(file.size)}}</div>
                                  <div class="file-close">
                                    <span class="text-danger" v-if="file.error">{{file.error}}</span>
                                    <span v-else-if="file.success">
                                      <i class="text-success fa fa-check-circle"></i>
                                    </span>
                                    <span v-else-if="file.active">active</span>
                                    <span v-else></span>

                                    <a
                                      href="#"
                                      @click.prevent="$refs.uploadbc.remove(file)"
                                      class="text-warning"
                                    >
                                      <i class="fa fa-trash-o"></i>
                                    </a>
                                  </div>
                                </div>

                                <div
                                  class="progress progress-xs progress-striped"
                                  v-if="file.active || file.progress !== '0.00'"
                                >
                                  <div
                                    class="progress-bar bg-success"
                                    role="progressbar"
                                    :style="{width: file.progress + '%'}"
                                  ></div>
                                </div>
                                <div
                                  class="upload-process"
                                  v-if="file.active || file.progress !== '0.00'"
                                >{{file.progress}}% done</div>
                              </li>
                            </ul>
                          </div>
                          <!-- </form> -->

                          <div class="col-sm-12 col-md-12">
                            <div class="alert alert-info">
                              <ul
                                style=" overflow-x: scroll;overflow-y: hidden;white-space:nowrap;"
                              >
                                <li class="text-wrap">Support files: {{extensions}}</li>
                                <li>MaxSize: 10Mb</li>
                              </ul>
                            </div>
                          </div>
                          <div
                            class="col-sm-12"
                            v-show="($refs.uploadbc && $refs.uploadbc.active==false) && broadcastParam.is_custom_url==false"
                          >
                            <div class="submit-section">
                              <div class="input-group mb-3">
                                <div class="input-group-prepend" v-show="false">
                                  <file-upload-bc
                                    :add-index="true"
                                    class="btn btn-outline-secondary"
                                    :data="objFilesMessageHandler"
                                    :post-action="uploadUrl"
                                    :multiple="false"
                                    :headers="headers"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="files"
                                    @input-filter="inputFilter"
                                    @input-file="inputFile"
                                    ref="uploadbc"
                                    :maximum="maximumUpload"
                                    :extensions="extensions"
                                  >
                                    <img src="@/assets/attachment.png" alt />
                                  </file-upload-bc>
                                </div>

                                <div class="input-group-append">
                                  <button
                                    v-if="false"
                                    @click.prevent="$refs.uploadbc.active = true"
                                    class="btn btn-outline-secondary"
                                    type="button"
                                  >Upload File</button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row" v-if="$refs.uploadbc && $refs.uploadbc.active==true">
                            <div class="col-sm-2">
                              <Skeleton :height="'40px'" :count="1" />
                            </div>
                            <div class="col-sm-2">
                              <Skeleton :height="'40px'" :count="1" />
                            </div>
                            <div class="col-sm-6">
                              <Skeleton :height="'40px'" :count="1" />
                            </div>
                            <div class="col-sm-2">
                              <Skeleton :height="'40px'" :count="1" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <Emoji
                  :open="emojiAttr.open"
                  :width="emojiAttr.width"
                  :height="emojiAttr.height"
                  searchLabel="Search emoji here"
                  @click="selectedEmoji"
                />
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>Message to send:</label>
                      <!-- {{broadcastParam}} -->
                      <div class="message-bar">
                        <div class="message-inner">
                          <a class="link attach-icon" @click.prevent="emojiToggle()">
                            <img style="width:30px;" src="@/assets/emoji.png" alt />
                          </a>
                          <div class="message-area">
                            <div class="input-group m-b-30">
                              <div class="input-group-prepend">
                                <div class="dropdown dropdown-action">
                                  <a
                                    href="#"
                                    class="action-icon dropdown-toggle text-info"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i class="material-icons">more_vert</i>
                                  </a>
                                  <div class="dropdown-menu dropdown-menu-right">
                                    <span style="margin:5px;">
                                      <b>
                                        <u>Template Message:</u>
                                      </b>
                                    </span>
                                    <template v-for="temp in templateMessage">
                                      <a
                                        class="dropdown-item"
                                        @click.prevent="addTemplateToMesage(temp)"
                                        :key="temp"
                                      >{{temp}}</a>
                                    </template>
                                  </div>
                                </div>
                              </div>

                              <textarea
                                :style="'height:300px'"
                                ref="messagebox"
                                class="form-control"
                                v-model="broadcastParam.message.text"
                                :placeholder="'Type message...'"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4 col-md-4">
                    <div class="row">
                      <div class="col-sm-12">
                        <label>Interactive Message</label>
                        <div class="onoffswitch">
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            class="onoffswitch-checkbox"
                            v-model="broadcastParam.interactive_message_status"
                            id="switch_interactive_message_status"
                          />
                          <label class="onoffswitch-label" for="switch_interactive_message_status">
                            <span class="onoffswitch-inner"></span>
                            <span class="onoffswitch-switch"></span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="broadcastParam.interactive_message_status==true">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="form-group form-focus select-focus">
                              <select
                                v-model="broadcastParam.interactive_message_type"
                                class="form-control"
                                @change="resetDetailButton"
                              >
                                <option :value="''">-- Select --</option>
                                <option
                                  v-for="(row,idxBtn) in interactiveMessageTypeList"
                                  :key="idxBtn"
                                  :value="row.id"
                                >{{row.label}}</option>
                              </select>
                              <label class="focus-label">Button Type</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style="margin-top:10px;"
                        class="col-sm-12"
                        v-if="broadcastParam.interactive_message_status==true"
                      >
                        <template v-if="broadcastParam.interactive_message_type=='list_text'">
                          <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                            <div class="form-group form-focus select-focus">
                              <select
                                v-model="broadcastParam.buttons[(index-1)]"
                                class="form-control"
                              >
                                <option :value="''">-- Select --</option>
                                <option
                                  v-for="(row,idxBtn) in buttonsRows"
                                  :key="idxBtn"
                                  :value="row.id"
                                >{{row.button_text}}</option>
                              </select>
                              <label class="focus-label">List {{index}}</label>
                            </div>
                          </div>
                        </template>
                        <template v-if="broadcastParam.interactive_message_type=='button_text'">
                          <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                            <div class="form-group form-focus select-focus" v-if="index<=3">
                              <select
                                v-model="broadcastParam.buttons[(index-1)]"
                                class="form-control"
                              >
                                <option :value="''">-- Select --</option>
                                <option
                                  v-for="(row,idxBtn) in buttonsRows"
                                  :key="idxBtn"
                                  :value="row.id"
                                >{{row.button_text}}</option>
                              </select>
                              <label class="focus-label">Button {{index}}</label>
                            </div>
                          </div>
                        </template>
                        <template v-if="broadcastParam.interactive_message_type=='action_link'">
                          <div v-for="index in defaultDetailButton" :key="index" class="col-md-12">
                            <div class="form-group form-focus select-focus" v-if="index<=3">
                              <select
                                v-model="broadcastParam.buttons[(index-1)]"
                                class="form-control"
                              >
                                <option :value="''">-- Select --</option>
                                <option
                                  v-for="(row,idxBtn) in linkRows"
                                  :key="idxBtn"
                                  :value="row.id"
                                >{{row.button_text}}</option>
                              </select>
                              <label class="focus-label">Link/Call {{index}}</label>
                            </div>
                          </div>
                        </template>
                      </div>

                      <div class="col-md-12" v-if="broadcastParam.interactive_message_status==true">
                        <div class="row">
                          <label>Configure Footer Message</label>
                          <div class="onoffswitch">
                            <input
                              type="checkbox"
                              name="onoffswitch"
                              class="onoffswitch-checkbox"
                              v-model="broadcastParam.footer_message_status"
                              id="switch_footer_message"
                            />
                            <label class="onoffswitch-label" for="switch_footer_message">
                              <span class="onoffswitch-inner"></span>
                              <span class="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-md-12"
                        v-if="broadcastParam.footer_message_status==true && broadcastParam.interactive_message_status==true"
                      >
                        <div class="form-group">
                          <label>Footer Message:</label>
                          <input
                            v-model="broadcastParam.footer_message"
                            placeholder="eq: Powered by Waajo.id"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3"></div>
                  <div class="col-md-9">
                    <div class="form-group">
                      <label>Sending Options:</label>
                      <div class="radio">
                        <label
                          :style="'margin-left:10px;'"
                          v-for="(row,index) in listSendingOptions"
                          :key="index"
                        >
                          <input
                            :id="row.id"
                            type="radio"
                            :value="row.id"
                            v-model="broadcastParam.sending_options"
                          />
                          {{row.label}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="broadcastParam.sending_options=='2'">
                  <div class="col-md-3"></div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Time to send:</label>
                      <!-- <input
                    type="text"
                    class="form-control datetimepicker"
                    v-model="broadcastParam.sending_options_schedule_date"
                      />-->

                      <div class="cal-icon">
                        <datetime
                          :min-datetime="currentDateTimeUTC()"
                          :zone="'local'"
                          :use12-hour="true"
                          input-class="form-control"
                          value-zone="UTC"
                          type="datetime"
                          v-model="broadcastParam.sending_schedule"
                        ></datetime>

                        <!-- <input type="text" class="form-control floating datetimepicker" /> -->
                      </div>
                      <!-- <span
                    v-if="broadcastParam.sending_schedule!=''"
                      >UTC: {{broadcastParam.sending_schedule}}</span>-->
                    </div>
                  </div>
                </div>
                <div class="row" v-if="broadcastParam.sending_options=='3'">
                  <div class="col-md-3"></div>
                  <div class="col-md-9">
                    <div class="form-group">
                      <div class="input-group m-b-30">
                        <!-- <label>Phone number to test:</label> -->
                        <input
                          type="text"
                          placeholder="Type phone number and separate with comma"
                          class="form-control"
                          v-model="broadcastParam.to_test_text"
                        />
                        <div class="input-group-append">
                          <button @click="bcMessageHandlerTest" class="btn btn-info" type="button">
                            <i class="fa fa-warning"></i> Send
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <scheduler />
            </div>
            <div
              :class="(tabMessage=='preview')?'tab-pane show active':'tab-pane' "
              id="preview"
              :style=" 'background: url(\''+whatsappBackground+'\');'"
            >
              <preview-message :buttonsRows="buttonsRows" :linkRows="linkRows" />
            </div>
          </div>
          <div class="submit-section">
            <div class="row">
              <div class="col-md-12" style="margin-bottom:10px;">
                <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                  <li class="nav-item">
                    <a
                      @click="settabMessage('setup')"
                      :class="(tabMessage=='setup')?'nav-link active':'nav-link' "
                      href="#form"
                      data-toggle="tab"
                    >Setup Message</a>
                  </li>
                  <li class="nav-item">
                    <a
                      @click="savePreview();settabMessage('preview')"
                      :class="(tabMessage=='preview')?'nav-link active':'nav-link' "
                      href="#preview"
                      data-toggle="tab"
                    >Preview Message</a>
                  </li>
                </ul>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <button
                      @click="bcMessageHandler(0)"
                      class="btn btn-md btn-warning"
                      type="button"
                    >
                      <i class="fa fa-save"></i> Draft
                    </button>

                    <button
                      @click.prevent="bcMessageHandler(1)"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-bullhorn"></i> Send
                    </button>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <button
                      v-if="broadcastParam.broadcast_id!='' && broadcastParam.is_recurring==1"
                      @click.prevent="bcMessageHandler(1,1)"
                      class="btn btn-lg btn-info"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-save"></i>
                      Update Only
                    </button>
                    <div
                      v-if="broadcastParam.broadcast_id!='' && broadcastParam.is_recurring==1"
                      class="text-muted"
                      style="font-size:11px;"
                    >*) Ignoring Send Now option.</div>
                  </center>
                  <center v-else>Processing...</center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import Scheduler from "./scheduler.vue";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import PreviewMessage from "./preview";

import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Scheduler,
    Datetime,
    PreviewMessage
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      tagsSelected: [],
      tagsOptions: [],
      tagsListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      interactiveMessageTypeList: [
        // { id: "button_text", label: "Button" },
        { id: "action_link", label: "Link/Call" },
        // { id: "list_text", label: "List" }
      ],
      tabMessage: "setup", //setup or preview
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      buttonsLoading: false,
      defaultDetailButton: 10,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      linkRows: [],
      buttonsRows: [],
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isSending: false,
      selectedLicense: [],
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      contactListGroupParam: {
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      },
      listSendingOptions: [
        { id: 1, label: "Send Now" },
        { id: 2, label: "Schedule" },
        { id: 3, label: "Send a test" }
      ],
      broadcastParam: {
        is_custom_url: false,
        broadcast_id: "",
        title: "",
        license_id: "",
        provider: "whatsapp",
        to_group: [],
        to: [],
        is_group: 1, //for group set 1, for personal set 0
        is_group_type: "group", //group/tags
        message: {
          text: "",
          message_type: "text", //text,image,document
          file_url: ""
        },
        sending_options: 1,
        sending_schedule: "",
        to_test: [],
        to_test_text: "",
        interactive_message_status: false,
        interactive_message_type: "action_link",
        footer_message_status: false,
        footer_message: "",
        buttons: ["", "", "", "", "", "", "", "", "", ""]
      },
      contactListParam: {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      },
      selectedContactGroup: [],
      contactOptionsGroup: [],
      isLoadingGroup: false,
      selectedContact: [],
      contactOptions: [],
      isLoading: false,
      textMessage: "",
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        message_type: ""
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document","video"],
      uploadMessageType: "image",
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },

      newData: [],
      currentGroupId: "",
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      }
    };
  },
  watch: {
    // broadcastParamSt: {
    //   handler: function(val, oldVal) {},
    //   deep: true
    // },
    selectedLicense: {
      handler: function(val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        if (val.length > 1 && val != oldVal) {
          var that = this;
          setTimeout(function() {
            // if (
            //   that.broadcastParam.broadcast_id != "" &&
            //   that.broadcastParam.broadcast_id != null
            // ) {
            let lengthOld = oldVal.length;
            val.splice(0, 1);
            that.selectedLicense = val;
            that.broadcastParam.license_id = val[0].id;
            return;
            // }
          }, 300);
        }

        // if (val != oldVal) {
        if (val.length == 1) {
          this.selectedLicense = val;
          this.broadcastParam.license_id = val[0].id;

          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedLicense = [];
          this.broadcastParam.license_id = "";

          return;
        }
        // else {
        //   this.selectedLicense = [];
        //   this.broadcastParam.license_id = "";
        //   return;
        // }
        // }
      },
      deep: true
    },
    uploadMessageSupportSelected: {
      handler: function(val, oldVal) {
        if (val == "media") {
          this.broadcastParam.message.message_type = this.uploadMessageType;
        } else {
          this.files = [];
          this.broadcastParam.message.file_url = "";
          this.broadcastParam.message.message_type = "text";
        }
      },
      deep: true
    },
    uploadMessageType: {
      handler: function(val, oldVal) {
        if (val != "") {
          this.broadcastParam.message.message_type = val;
        } else {
          this.broadcastParam.message.message_type = "text";
        }
      },
      deep: true
    },
    isShowBroadcast: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          this.settabMessage("setup");

          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.broadcastParamSt.broadcast_id != "" &&
              that.broadcastParamSt.broadcast_id != null
            ) {
              that.selectedLicense = [];

              that.broadcastParam = that.broadcastParamSt;
              that.broadcastParam.title = that.detailBroadcast.title;
              if (that.broadcastParam.license_id != "") {
                that.asyncFindLicense("", that.broadcastParam.license_id);
              }
              if (that.detailBroadcast.is_group == 0) {
                that.selectedContact = that.broadcastParam.to;
              } else if (that.detailBroadcast.is_group == 1) {
                if (that.broadcastParam.is_group_type == "tags") {
                  that.tagsSelected = that.broadcastParam.to_group;
                } else {
                  that.selectedContactGroup = that.broadcastParam.to_group;
                }
              }

              if (
                that.broadcastParam.buttons.length < that.defaultDetailButton
              ) {
                let kekuranganBtn =
                  that.defaultDetailButton - that.broadcastParam.buttons.length;
                for (var i = 0; i < kekuranganBtn; i++) {
                  that.broadcastParam.buttons.push("");
                }
              }

              that.broadcastParam.message.message_type =
                that.detailBroadcast.message_type;
              that.broadcastParam.message.file_url =
                that.detailBroadcast.message_media;
              // console.log("that.broadcastParam.message.file_url",that.broadcastParam.message.file_url)
              if (that.broadcastParam.message.message_type != "text") {
                that.uploadMessageType =
                  that.broadcastParam.message.message_type;
                that.updateMessageSupportCurrent("media");
              } else {
                that.updateMessageSupportCurrent("text only");
              }

              that.loadReplyButtons();
              that.loadReplyLink();
            } else {
              that.selectedLicense = [];

              that.asyncFindLicense("", "");
              that.loadReplyButtons();
              that.loadReplyLink();

              that.broadcastParam = {
                is_custom_url: false,
                broadcast_id: "",
                title: "",
                license_id: "",
                provider: "whatsapp",
                to_group: [],
                to: [],
                is_group: 1, //for group set 1, for personal set 0
                is_group_type: "group", //for group set 1, for personal set 0
                message: {
                  text: "",
                  message_type: "text", //text,image,document
                  file_url: ""
                },
                sending_options: 1,
                sending_schedule: "",
                to_test: [],
                interactive_message_status: false,
                interactive_message_type: "action_link",
                buttons: ["", "", "", "", "", "", "", "", "", ""],
                footer_message_status: false,
                footer_message: ""
              };
            }
          }, 100);
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: row.phone_number,
              phone_number_group: row.phone_number_group,
              is_group: row.is_group,
              first_name: row.first_name,
              provider: row.provider
            };
            this.broadcastParam.to.push(newDest);
          });
        } else {
          this.broadcastParam.to = [];
        }
      },
      deep: true
    },
    selectedContactGroup: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to_group = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: 0,
              name: row.name,
              first_name: row.name,
              phone_number_group: "",
              is_group: 1
            };
            this.broadcastParam.to_group.push(newDest);
          });
        } else {
          this.broadcastParam.to_group = [];
        }
      },
      deep: true
    },
    tagsSelected: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to_group = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: 0,
              phone_number_group: "",
              is_group: 1,
              first_name: row.name,
              name: row.name
            };
            this.broadcastParam.to_group.push(newDest);
          });
        } else {
          this.broadcastParam.to_group = [];
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    },
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    },
    isShowBroadcast() {
      return this.$store.state.omniroom.isShowBroadcast;
    },
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    }
  },
  methods: {
    tagsLimitText(count) {
      return ` ${count} other`;
    },
    tagsCustomLabel({ name }) {
      return `${name}`;
    },
    tagsAsyncFind(query) {
      this.isLoading = true;
      this.tagsListParam.name = query;
      this.$store
        .dispatch("crm/listTagsBC", this.tagsListParam)
        .then(response => {
          this.isLoading = false;
          this.tagsOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    settabMessage(value) {
      this.tabMessage = value;
    },
    resetDetailButton() {
      this.broadcastParam.buttons = ["", "", "", "", "", "", "", "", "", ""];
    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    addTemplateToMesage(template) {
      this.broadcastParam.message.text += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    customLabelLicense({ license_name, license_phone_number }) {
      if (typeof license_name != "undefined") {
        return `${license_name} – ${license_phone_number}`;
      }
    },
    asyncFindLicenseSelect(query) {
      // if (query == "") {
      //   return false;
      // }
      this.licenseOptions = [];
      // this.isLoadingLicense = true;
      this.licenseListParam.license_name = query;
      // if (query == "") {
      //   return;
      // }

      this.licenseListParam.id = "";
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          // this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
          // console.log("licenseOptions", this.licenseOptions);

          // console.log("query: ", query);
          // console.log("contactOptions: ", this.licenseOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          // this.isLoadingLicense = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    asyncFindLicense(query, id) {
      // if (query == "") {
      //   return false;
      // }
      // this.isLoadingLicense = true;
      this.licenseListParam.license_name = query;
      if (typeof id != "undefined" && id != "") {
        this.licenseListParam.id = id;
      } else {
        this.licenseListParam.id = "";
      }
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          this.isLoadingLicense = false;
          this.licenseOptions = response.data.data;
          // console.log("licenseOptions", this.licenseOptions);
          if (
            typeof id != "undefined" &&
            id != "" &&
            this.licenseOptions.length > 0
          ) {
            this.selectedLicense = this.licenseOptions;
          }
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.licenseOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingLicense = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAllLicense() {
      this.selectedLicense = [];
    },
    async buildDestinationFromGroup() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      await this.$store
        .dispatch("contact/getContactList", this.contactListParam)
        .then(response => {
          let { data } = response;
          data.forEach((rowCon, ind) => {
            let arrCon = {
              id: rowCon.id,
              phone_number: rowCon.phone_number,
              is_group: rowCon.is_group,
              phone_number_group: rowCon.phone_number_group
            };
            this.broadcastParam.to.push(arrCon);
          });
        });
    },
    async buildDestinationFromTags() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      await this.$store
        .dispatch("contact/getContactListFromTags", this.contactListParam)
        .then(response => {
          let { data } = response;
          data.forEach((rowCon, ind) => {
            let arrCon = {
              id: rowCon.id,
              phone_number: rowCon.phone_number,
              is_group: rowCon.is_group,
              phone_number_group: rowCon.phone_number_group
            };
            this.broadcastParam.to.push(arrCon);
          });
        });
    },
    customLabelGroup({ name }) {
      return `${name}`;
    },
    asyncFindGroup(query) {
      this.isLoadingGroup = true;
      this.contactListGroupParam.name = query;
      this.$store
        .dispatch("contact/getGroupList", this.contactListGroupParam)
        .then(response => {
          this.isLoadingGroup = false;
          this.contactOptionsGroup = response.data;
          // console.log("query: ", query);
          // console.log("contactOptionsGroup: ", this.contactOptionsGroup);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingGroup = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    changeDestination(isGroup, isGroupType) {
      this.broadcastParam.is_group = isGroup;
      this.broadcastParam.is_group_type = isGroupType;
      this.broadcastParam.to = [];
      this.broadcastParam.to_group = [];
      this.selectedContactGroup = [];
      this.tagsSelected = [];
      this.selectedContact = [];
      this.contactListParam = {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      };
      this.contactListGroupParam = {
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      };
      this.tagsListParam = {
        name: "",
        page: 0,
        perPage: 10
      };
    },
    async savePreview() {
      // console.log("bc",)
      this.broadcastParam.message.text = await this.remove_tags(
        this.broadcastParam.message.text
      );

      await this.$store.dispatch(
        "omniwa/actBroadcastParamSt",
        this.broadcastParam
      );
    },
    async bcMessageHandler(isSend = 0, updateOnly = 0) {
      this.broadcastParam.to_test = [];

      if (isSend == 0) {
        this.broadcastParam.is_send = 0;
      } else {
        this.broadcastParam.is_send = 1;
      }
      if (this.broadcastParam.is_group == 1) {
        if (this.broadcastParam.to_group.length == 0) {
          //error no destination
          // error
          this.$fire({
            title: "Error",
            text: "Destination is required!",
            type: "error",
            timer: 2000
          }).then(r => {});
          return;
        }
        if (this.broadcastParam.is_group_type == "tags") {
          await this.buildDestinationFromTags();
        } else {
          await this.buildDestinationFromGroup();
        }
      }

      //validasi data
      if (
        this.broadcastParam.to.length == 0 &&
        this.broadcastParam.to_group.length == 0
      ) {
        //error no destination
        // error
        this.$fire({
          title: "Error",
          text: "Destination is required!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }
      if (
        this.broadcastParam.message.message_type != "text" &&
        this.broadcastParam.message.file_url == ""
      ) {
        //error no media
        this.$fire({
          title: "Error",
          text:
            "File is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      if (
        this.broadcastParam.message.message_type == "text" &&
        this.broadcastParam.message.text.trim() == ""
      ) {
        //error no text for type text
        this.$fire({
          title: "Error",
          text:
            "Text is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      // return;

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          if (updateOnly == 1) {
            //maka hanya update data
            this.broadcastParam.update_only = true;
          } else {
            this.broadcastParam.update_only = false;
          }

          this.isSending = await true;
          this.emojiToggle(false);
          this.broadcastParam.message.text = await this.remove_tags(
            this.broadcastParam.message.text
          );

          this.broadcastParam.is_recurring = this.broadcastParamSt.is_recurring;
          this.broadcastParam.recurring_form = this.broadcastParamSt.recurring_form;

          let newButtons = [];
          // console.log("this.broadcastParam.buttons",this.broadcastParam.buttons)
          if (this.broadcastParam.interactive_message_status == true) {
            // newButtons = this.broadcastParam.buttons;
            if (this.broadcastParam.buttons.length) {
              this.broadcastParam.buttons.forEach((btnId, idx) => {
                if (btnId != "") {
                  newButtons.push(btnId);
                }
              });
            }
          }

          this.broadcastParam.buttons = newButtons;
          // console.log("newButtons", newButtons);
          await this.$store
            .dispatch("omniwa/sendBroadcast", this.broadcastParam)
            .then(response => {
              this.files = [];
              this.selectedLicense = [];
              this.selectedContactGroup = [];
              this.selectedContact = [];
              // this.isSending = false;
              if (this.broadcastParam.broadcast_id == "") {
                this.broadcastParam = {
                  //from state
                  title: "",
                  provider: "whatsapp",
                  to_group: [],
                  to: [],
                  is_group: this.broadcastParam.is_group, //for group set 1, for personal set 0
                  is_group_type: this.broadcastParam.is_group_type, //group/tags
                  license_id: "",
                  message: {
                    text: "",
                    message_type: this.broadcastParam.message.message_type, //text,image,document
                    file_url: ""
                  },
                  sending_options: 1,
                  sending_schedule: "",
                  is_recurring: 0,
                  recurring_form: {
                    recurrence: "",
                    recurrence_every: "",
                    recurrence_annually_month: "",
                    recurrence_end: "never",
                    recurrence_end_date: ""
                  },
                  is_send: 1,
                  to_test: [],
                  interactive_message_status: false,
                  interactive_message_type: "action_link",
                  buttons: ["", "", "", "", "", "", "", "", "", ""]
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              var elem = this.$refs.dismisModal;
              elem.click();
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    async buildDestinationTest() {
      this.broadcastParam.to_test = [];
      this.broadcastParam.to_test_text = this.broadcastParam.to_test_text.replace(
        /^\s+|\s+$/gm,
        ""
      );

      if (this.broadcastParam.to_test_text != "") {
        var toTestArr = this.broadcastParam.to_test_text.split(",");
        toTestArr.forEach((phoneNumber, idx) => {
          phoneNumber = phoneNumber.replace(/^\s+|\s+$/gm, "");
          let oriNumber = phoneNumber;
          phoneNumber = parseInt(phoneNumber);
          if (phoneNumber != "" && !isNaN(phoneNumber)) {
            let newArr = {
              id: idx.toString(),
              phone_number: oriNumber
            };
            this.broadcastParam.to_test.push(newArr);
          }
        });
      }
    },
    async bcMessageHandlerTest() {
      await this.buildDestinationTest();
      console.log("this.totest", this.broadcastParam.to_test);
      this.broadcastParam.is_send = 1;

      //validasi data
      if (
        this.broadcastParam.to_test.length == 0 ||
        this.broadcastParam.to_test_text == ""
      ) {
        //error no destination
        // error
        this.$fire({
          title: "Error",
          text: "Test Destination is required!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }
      if (
        this.broadcastParam.message.message_type != "text" &&
        this.broadcastParam.message.file_url == ""
      ) {
        //error no media
        this.$fire({
          title: "Error",
          text:
            "File is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      if (
        this.broadcastParam.message.message_type == "text" &&
        this.broadcastParam.message.text.trim() == ""
      ) {
        //error no text for type text
        this.$fire({
          title: "Error",
          text:
            "Text is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      // return;

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          this.isSending = await true;
          this.emojiToggle(false);
          var origText = this.broadcastParam.message.text;
          this.broadcastParam.message.text = await this.remove_tags(
            this.broadcastParam.message.text
          );
          let newButtons = [];
          // console.log("this.broadcastParam.buttons",this.broadcastParam.buttons)
          if (this.broadcastParam.interactive_message_status == true) {
            // newButtons = this.broadcastParam.buttons;
            if (this.broadcastParam.buttons.length) {
              this.broadcastParam.buttons.forEach((btnId, idx) => {
                if (btnId != "") {
                  newButtons.push(btnId);
                }
              });
            }
          }

          this.broadcastParam.buttons = newButtons;
          await this.$store
            .dispatch("omniwa/sendBroadcastTest", this.broadcastParam)
            .then(response => {
              this.$fire({
                title: "Success Test",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
        this.broadcastParam.message.text = origText;
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    inputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        // this.bcMessageHandler();
      }
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ first_name, phone_number, provider, is_group }) {
      if (is_group == 1) {
        return `${first_name} – ${provider}`;
      } else {
        return `${first_name} – ${phone_number}`;
      }
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.keywords = query;
      this.$store
        .dispatch("contact/getContactList", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data;
          console.log("query: ", query);
          console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAll() {
      this.selectedContact = [];
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.broadcastParam.message.text += args.emoji;
      // console.log(args); /* return {...}*/
    },
    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      this.uploadMessageType = msgType;
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => {});
        }
        if (newFile.success && !oldFile.success) {
          this.broadcastParam.message.file_url = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.broadcastParam.message.file_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    }
  },
  async created() {
    this.asyncFindLicenseSelect();
  },
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-add"
};
</script>


// WEBPACK FOOTER //
// src/views/messageReport/broadcast-add.vue